import _ from 'lodash';
import { getUserAssignmentTypeDisplay } from '../../libs/user';

//- Need to hide the "istPast" assignments

export function getAssignmentBreakdowns(p) {
	const { locationMap, userAssignments, equipmentAssignments } = p;

	// Go through all users and tally up stats
	// Add truck stats second
	const byLocationId = {};
	userAssignments.forEach((userAssignment) => {
		const {
			locationId,
			shiftId,
			shiftTime,
			isPast,
			isNotCurrent,
			userAssignmentTypeId,
		} = userAssignment;

		if (isPast || isNotCurrent) {
			return;
		}

		const location = locationMap[locationId] || { display: 'Missing' };
		if (!byLocationId[locationId]) {
			byLocationId[locationId] = {
				location,
				locationId,
				count: 0,
				equipmentCount: 0,

				sort: location.display,
				byShiftId: {},
			};
		}
		const locationRef = byLocationId[locationId];
		locationRef.count++;

		if (!locationRef.byShiftId[shiftId]) {
			//- Get all the possible trucks for this location for this shift
			locationRef.byShiftId[shiftId] = {
				shiftId,
				count: 0,
				userAssignmentTypeStats: {},
			};
		}

		const shiftRef = locationRef.byShiftId[shiftId];
		shiftRef.count++;

		//const userAssignmentType = getUserAssignmentType({ userAssignmentTypeId });

		//- Tally up the # of drivers on each schedule
		if (!shiftRef.userAssignmentTypeStats[userAssignmentTypeId]) {
			shiftRef.userAssignmentTypeStats[userAssignmentTypeId] = {
				userAssignmentTypeId,
				list: [],
				count: 0,
			};
		}

		const statRef = shiftRef.userAssignmentTypeStats[userAssignmentTypeId];
		statRef.count++;

		statRef.list.push({
			shiftTime,
			userAssignment,
		});
	});

	equipmentAssignments.forEach((equipmentAssignment) => {
		const { locationId } = equipmentAssignment;
		if (!byLocationId[locationId]) {
			console.error('FOUND A LOCATION WITH NOW USER ASSIGNMENTS', locationId);
			return;
		}
		byLocationId[locationId].equipmentCount++;
	});

	const assignmentBreakdowns = [];
	_.sortBy(_.values(byLocationId), 'sort').forEach((byLocationValue) => {
		const { location, count, equipmentCount, byShiftId } = byLocationValue;

		//- Final row to push
		const breakdownRow = {
			location,
			count,
			equipmentCount,
			shiftRows: [],
		};

		_.sortBy(_.values(byShiftId), 'shiftId').forEach((byShiftValue) => {
			const { shiftId, count, userAssignmentTypeStats } = byShiftValue;

			const scheduleStatRows = [];
			_.sortBy(_.values(userAssignmentTypeStats), 'userAssignmentTypeId').forEach((typeValue) => {
				const { userAssignmentTypeId, count, list } = typeValue;

				scheduleStatRows.push({
					userAssignmentTypeId,
					scheduleDisplay: getUserAssignmentTypeDisplay({ userAssignmentTypeId }),
					list: _.sortBy(list, 'shiftTime'),
					count,
				});
			});

			breakdownRow.shiftRows.push({
				shiftId,
				count,
				scheduleStatRows,
			});
		});

		assignmentBreakdowns.push(breakdownRow);
	});

	console.log(assignmentBreakdowns);
	return { assignmentBreakdowns };
}
